/**
 * @file RedirectOldSlugCheck.tsx
 * @description Галочка «Переадресовать со старого адреса» под полем адреса
 * товара, категории, статьи и рубрики (phase19.16, партия Р3в, v0.19.64;
 * SB131; контракт r3v-api-contract §3): появляется, когда адрес меняют у
 * уже сохранённой сущности; по умолчанию отмечена (практика Shopify).
 * Правило создаётся, только если старый адрес был живым на сайте (решает
 * сервер) — отсюда подпись «если страница видна на сайте». Снятая — старые
 * ссылки перестанут работать. Строка от 48 px.
 */

import { CheckRow } from "../site-view/CheckRow";

interface Props {
  /** Адрес на сайте сейчас: `/product/ivan-chai`. */
  oldPath: string;
  /** Адрес изменён в форме — иначе галочки нет. */
  changed: boolean;
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export function RedirectOldSlugCheck({ oldPath, changed, checked, onChange, disabled = false }: Props) {
  if (!changed) return null;
  return (
    <div className="flex flex-col gap-0.5" data-testid="redirect-old-slug">
      <CheckRow checked={checked} disabled={disabled} onChange={onChange}>
        <span className="min-w-0 break-words">Переадресовать со старого адреса {oldPath}</span>
      </CheckRow>
      <p className="type-caption pl-7 text-on-surface-variant">
        {checked
          ? "Покупатели и поисковики со старого адреса попадут на новый (если страница видна на сайте)."
          : "Старые ссылки на этот адрес перестанут работать."}
      </p>
    </div>
  );
}
